import FilteredDateHistoryResult from '@di-shared/features/history/filtered/FilteredDateHistoryResult';

interface FilteredDateHistoryResultPageProps {
  vin: string;
}

export default function FilteredDateHistoryResultPage({vin}: FilteredDateHistoryResultPageProps) {
  return <FilteredDateHistoryResult vin={vin} />;
}
